export class Modelo{
    public constructor(
        public id:String = "",
        public nombre: String = "",
        public marca_id: String = "",
        public empresa_id: String = "",
        public usuario_id:String = null
    ){
        //
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/modelo.ts